import React from "react"
import { Box } from "reflexbox/styled-components"
import { MobileHeaderFlex, MobileHeaderIcon } from "./elements"
import ListItem from "./ListItem"


const MobileListHeader = (props) => {
  return (
    <MobileHeaderFlex>
      <Box width={3/4}>
        <ListItem title={props.title} compact/>
      </Box>
      <Box width={1/4} pr={1}>
        <MobileHeaderIcon>{props.open ? "-" : "+"}</MobileHeaderIcon>
      </Box>
    </MobileHeaderFlex>
  )
}

export default MobileListHeader
